const updateListData = (state, payload) => {
  state.listData = payload
}

const updatePagination = (state, payload) => {
  state.pagination = payload
}

const resetList = (state) => {
  state.listData = null
}

const updateValidationMessage = (state, payload) => {
  state.validationMessage = payload
}

export default {
  updateListData,
  updatePagination,
  resetList,
  updateValidationMessage,
}
